var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-delete-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83868b",
    d: "M16 1.898c-7.79 0-14.102 6.314-14.102 14.102s6.312 14.102 14.102 14.102 14.102-6.314 14.102-14.102-6.312-14.102-14.102-14.102zM21.472 19.35c0.586 0.586 0.586 1.536 0 2.122-0.292 0.292-0.676 0.44-1.060 0.44s-0.768-0.146-1.060-0.44l-3.352-3.35-3.352 3.35c-0.292 0.292-0.678 0.44-1.060 0.44-0.384 0-0.768-0.146-1.060-0.44-0.586-0.586-0.586-1.536 0-2.122l3.35-3.35-3.35-3.35c-0.586-0.586-0.586-1.536 0-2.122s1.536-0.586 2.122 0l3.35 3.35 3.352-3.35c0.588-0.588 1.538-0.584 2.122 0 0.586 0.586 0.586 1.536 0 2.122l-3.352 3.35 3.35 3.35z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteCircle);
export default __webpack_public_path__ + "static/media/icon-delete-circle.0307b61f.svg";
export { ForwardRef as ReactComponent };